import { useQuery } from '@tanstack/react-query';

import { LereToursPricingHistoryParams } from '~/components/LERE/types';

import LereService from '~/services/LereService';

import { lereToursPricingHistoryQueryKeys } from './lereToursPricingHistoryQueryKeys';

export function useGetToursPricingHistory(params: LereToursPricingHistoryParams) {
  return useQuery({
    queryKey: lereToursPricingHistoryQueryKeys.list(params),
    queryFn: async ({ signal }) => {
      return await LereService.getToursPricingHistory(params, { signal });
    },
    placeholderData: (previousData) => previousData,
    retry: false,
  });
}
